import faq from "@/data/faq"
import glossary from "@/data/glossary"

export default {
    findFaqs() {
        return Promise.resolve({
            faqs: faq(),
        })
    },

    findGlossaryEntries() {
        return Promise.resolve({
            entries: glossary(),
        })
    },
}